import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ChangeOrderStatus} from '../../../../types/enums';
import {ChangeOrderGridData} from '../types/ChangeOrderGridData';

export const useGetChangeOrders = (changeOrderStatus?: ChangeOrderStatus) => {
    const { data, isLoading } = useQuery({
        queryKey: ['action-required-orders', changeOrderStatus],
        queryFn: async () => await apiClient.get('action-required/change-orders',
            {
                params: {
                    changeOrderStatus
                }
            }) as ChangeOrderGridData
    });

    return {
        data,
        isLoading
    };
};
